import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Building2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { PartnerFields } from "@/components/PartnerFields";
import { Button } from "@/components/ui/button";

export default function CompanyProfile() {
  const { t } = useI18n();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get("/partners/me").then(({ data }) => setForm(data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);

  const save = async () => {
    const fields = ["company_name", "vat_number", "tax_code", "registration_number", "contact_name",
      "phone", "email", "address", "city", "postal_code", "country",
      "bank_name", "account_holder", "iban", "swift", "bank_country"];
    const out = {};
    fields.forEach((k) => { out[k] = form[k] === "" ? null : form[k]; });
    try { const { data } = await api.put("/partners/me", out); setForm(data); toast.success("Profilo aggiornato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!form) return <div className="text-slate-400 py-10">{t("common.loading")}</div>;

  return (
    <div className="space-y-6 max-w-3xl" data-testid="company-profile-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-slate-900 flex items-center gap-2"><Building2 size={24} className="text-blue-900" /> La mia azienda</h1>
          <p className="text-sm text-slate-500 mt-1">Gestisci i dati aziendali e bancari</p>
        </div>
        <Button onClick={save} className="bg-blue-900 hover:bg-blue-800" data-testid="company-save-btn"><Save size={16} className="mr-1.5" /> {t("common.save")}</Button>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <PartnerFields form={form} setForm={setForm} adminMode={false} />
      </div>
    </div>
  );
}
